<!-- <div class="dialog">
    <h1 [ngClass]="[message]">{{socketData1}}</h1>
</div> -->
<div>
    <h1>{{socketData1}}</h1>
</div>